import { get } from 'src/utils/EntryUtil';
import { LocalStorage } from 'src/utils/LocalStorage';

const SALES_CHANNEL_SYS_ID_KEY = 'salesChannelSysId';
const COMMERCE_CART_ITEMS_PREFIX = 'commerce.cart.items';

export function getCartItemLength(): number {
  const salesChannelSysId = LocalStorage.tryGetItem(SALES_CHANNEL_SYS_ID_KEY);

  const cartKey = [COMMERCE_CART_ITEMS_PREFIX, salesChannelSysId].filter(s => !!s).join('.');

  const items = LocalStorage.tryGetJSONItem(cartKey);

  if (!Array.isArray(items)) return 0;

  return items.reduce((sum, item) => sum + get(item, 'quantity', 0), 0);
}
